import Scrollable from "@components/ui/Scrollable";
import { ComponentElem, ScrollableSetting } from "@components/interfaces";
import { Emitter } from "strict-event-emitter";

export default class HashtagList extends Scrollable
{
  emitter: Emitter<{ "change": [hashtag: string] }>;

  constructor(elem: ComponentElem, selectedId?: string)
  {    
    super(elem, {
      itemWidth: 0,
      itemHeight: 40,
      gapX: 10,
      gapY: 10,
      numCols: 5,
      buttonMode: "press"
    }, {
      itemWidth: 0,
      itemHeight: 40,
      gapX: 10,
      gapY: 10,
      numCols: 5,
      buttonMode: "press"
    });

    this.emitter = new Emitter();

    let selected: HTMLElement = null;

    let $hashTags = this.$root.find('[component="hashtag"]'),
      hashtagList: HashtagList = (this.$root[0] as ComponentElem)._component;

    $.each($hashTags, (index: number, elem: HTMLElement) =>
    {
      (elem.dataset.id === selectedId) ?
        elem.setAttribute("selected", "true") :
        elem.removeAttribute("selected");

      $(elem).on("click", (event: Event) =>
      {
        event.preventDefault();

        if (hashtagList.isDragging) return;

        selected = elem;

        $hashTags.removeAttr("selected");
        if (selected !== null) selected.setAttribute("selected", "true");
        this.emitter.emit("change", selected.dataset.id);
      });
    });
  }
}